import { JwtContent } from 'store/user/user.reducer';
import { Platform } from 'clients/manager/platforms.requests';
import { TypeAccess } from 'common/interfaces/user.interface';
import { getDisputeHash } from './get-dispute-hash.utils';
import { apiRedirectTo, getUrlOAuth2 } from '../navigation';

export const getDisputeUrl = (
    processId: number | string,
    tokenContent: JwtContent | undefined,
    service: string,
    platform: Platform | undefined,
    loginBaseUrl: string
) => {
    if (!platform?.apps?.dispute) return '';
    const hash = getDisputeHash(processId, tokenContent);
    const sufix = `&auction=${processId}&hash=${hash}&service=${service}`;
    const clientId = process.env.REACT_APP_DISPUTE_CLIENT_ID;
    let disputeBaseUrl = '';

    if (process.env.REACT_APP_NODE_ENV === 'local') {
        disputeBaseUrl = 'http://localhost:3000';
    } else {
        disputeBaseUrl = `${platform.apps?.dispute}`;
    }

    const typeAccess: TypeAccess | undefined = tokenContent?.typeAccess as TypeAccess;
    let resourceId: number | undefined | null = null;
    switch (typeAccess) {
        case TypeAccess.provider:
            resourceId = tokenContent?.providerId;
            break;
        case TypeAccess.organization:
            resourceId = tokenContent?.organizationId;
            break;
        default:
            break;
    }
    const redirectUrl = getUrlOAuth2(
        typeAccess,
        resourceId ? `${resourceId}` : null,
        `${sufix}`,
        disputeBaseUrl,
        tokenContent?.userId ? `${tokenContent?.userId}` : undefined,
        clientId
    );

    const url = apiRedirectTo({
        backofficeRedirectUrl: loginBaseUrl,
        redirectUrl,
        isPublic: true,
        isDisableRedirect: true,
    });

    return `${url}`;
};
